module.exports = __webpack_public_path__ + "img/30.ffd6a78e.jpg";